import Alert from '@mui/material/Alert'
import AlertTitle from '@mui/material/AlertTitle'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import Typography from '@mui/material/Typography'
import type { ReactNode } from 'react'
import { describeError, errorCode } from '../api/client'

export function LoadingBlock({ label = 'Loading...' }: { label?: string }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, py: 6, justifyContent: 'center' }}>
      <CircularProgress size={22} />
      <Typography color="text.secondary">{label}</Typography>
    </Box>
  )
}

export function ErrorBlock({ error, title = 'Could not load this' }: { error: unknown; title?: string }) {
  const code = errorCode(error)
  return (
    <Alert severity="error" sx={{ whiteSpace: 'pre-line' }}>
      <AlertTitle>{title}</AlertTitle>
      {describeError(error)}
      {code && (
        <Typography variant="caption" sx={{ display: 'block', mt: 0.5, opacity: 0.8 }}>
          {code}
        </Typography>
      )}
    </Alert>
  )
}

export function EmptyState({ message, action }: { message: string; action?: ReactNode }) {
  return (
    <Box sx={{ py: 6, textAlign: 'center' }}>
      <Typography color="text.secondary" sx={{ mb: action ? 2 : 0 }}>
        {message}
      </Typography>
      {action}
    </Box>
  )
}
